export const openIntercom = () => {
  if (window.Intercom) {
    window.document.documentElement.setAttribute("data-show-intercom", "true");
    window.Intercom("show");
    window.Intercom("onHide", () => {
      window.document.documentElement.removeAttribute("data-show-intercom");
    });
  } else if (process.env.NODE_ENV === "development") {
    alert("Intercom is opened!");
  }
};

export const openIntercomMessage = (message?: string) => {
  openIntercom();

  if (process.env.REACT_APP_ENV !== "production") {
    console.log("INTERCOM MESSAGE:", message);
  }

  if (window.Intercom) {
    window.Intercom("showNewMessage", message);
  }
};
